import React from 'react'
import PropTypes from 'prop-types'
import { Map as BaseMap, Marker, TileLayer, Polygon } from 'react-leaflet'
import L from 'leaflet'

import 'leaflet/dist/leaflet.css'
import 'leaflet-draw/dist/leaflet.draw.css'


// Some leaflet fix
delete L.Icon.Default.prototype._getIconUrl // eslint-disable-line no-underscore-dangle
L.Icon.Default.mergeOptions({
    iconRetinaUrl : require('leaflet/dist/images/marker-icon-2x.png'), // eslint-disable-line global-require
    iconUrl       : require('leaflet/dist/images/marker-icon.png'), // eslint-disable-line global-require
    shadowUrl     : require('leaflet/dist/images/marker-shadow.png') // eslint-disable-line global-require
})

const Map = ({ children, zoom, ...props }) => (
    <BaseMap
        zoom={ zoom }
        style={ { height: '450px', zIndex: 1, flexGrow: 1 } }
        { ...props }
    >
        { children }
        <TileLayer
            attribution="&amp;copy <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
        />
    </BaseMap>
)

Map.propTypes = {
    zoom: PropTypes.number
}

Map.defaultProps = {
    zoom: 14
}

export default Map
export { Marker, Polygon }
